import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const AdminVideoSolutionDataDeleteButton = ({
  id,
  path,
  sil,
  tumunuSil = false
}) => {

  const [loading, setLoading] = useState(false);

  const handleButtonClick = async () => {

    const message = tumunuSil
      ? "TÜM DENEMELER SİLİNECEK!\n\nBu işlem geri alınamaz. Emin misiniz?"
      : `"${path}" denemesi silinsin mi?`;

    const confirmed = window.confirm(message);

    if (!confirmed) {
      return;
    }

    try {

      setLoading(true);

      if (tumunuSil) {
        await sil();
      } else {
        await sil(id);
      }

    } catch (error) {

      console.error(error);

    } finally {

      setLoading(false);

    }
  };


  return (
    <button
      className="btn btn-danger"
      onClick={handleButtonClick}
      disabled={loading}
      title={tumunuSil ? "Tüm Denemeleri Sil" : `${path} Sil`}
      style={{
        marginLeft: "10px",
        minWidth: "40px"
      }}
    >

      {loading ? (
        "..."
      ) : (
        <FontAwesomeIcon icon={faTrash} />
      )}

    </button>
  );
};

export default AdminVideoSolutionDataDeleteButton;